import { Link, Navigate, useParams } from 'react-router-dom'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import CatalystCaseStudy from './CatalystCaseStudy'
import AzureCaseStudy from './AzureCaseStudy'
import { FEATURED_PROJECTS } from '../data/projects'

const REGISTRY: Record<string, React.FC<{ standalone?: boolean }>> = {
  catalyst: CatalystCaseStudy,
  'azure-zero-trust': AzureCaseStudy,
}

const ProjectDetail: React.FC = () => {
  const { projectId } = useParams()
  const CaseStudy = projectId ? REGISTRY[projectId] : undefined

  if (!CaseStudy || !projectId) return <Navigate to="/" replace />

  const currentIdx = FEATURED_PROJECTS.findIndex((p) => p.id === projectId)
  const nextProject =
    currentIdx === -1
      ? null
      : FEATURED_PROJECTS[(currentIdx + 1) % FEATURED_PROJECTS.length]

  return (
    <main id="main-content">
      <div className="pt-20 sm:pt-24">
        <div className="container-width">
          <Link
            to="/"
            className="inline-flex items-center gap-2 mono-label text-neutral-500 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-300 transition-colors duration-200"
          >
            <ArrowLeft size={14} />
            Back to projects
          </Link>
        </div>
      </div>
      <CaseStudy standalone />

      {nextProject && (
        <section className="border-t border-neutral-200 dark:border-white/8 bg-neutral-50 dark:bg-neutral-900/30 py-10">
          <div className="container-width flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <Link
              to="/"
              className="mono-label text-neutral-500 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-300 transition-colors"
            >
              ← All projects
            </Link>
            <Link
              to={`/projects/${nextProject.id}`}
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 dark:text-primary-400 hover:text-primary-500 transition-colors group"
            >
              <span className="group-hover:underline">Next case study — {nextProject.title}</span>
              <ArrowRight size={15} />
            </Link>
          </div>
        </section>
      )}
    </main>
  )
}

export default ProjectDetail